module.exports = __webpack_public_path__ + "img/viber.e14f5bc.png";